import * as React from 'react';
import {API} from 'aws-amplify';
import * as mutations from '../graphql/mutations';

import {Controller} from 'react-hook-form';
import {Form, DetailItem, FieldWrapper} from '../Global/StyledComponents';
import {TextField, Button} from '@material-ui/core';

const HelpsTypeForm = ({
	setActiveView,
	help,
	helpsForm,
	setRefreshHelps,
	editMode,
}) => {
	async function createHelp(help) {
		console.log([help]);
		const response = await API.graphql({
			query: mutations.createHelpType,
			variables: {input: help},
			authMode: 'AMAZON_COGNITO_USER_POOLS',
		});
		console.log(response);
		return response;
	}
	async function updateHelp(help) {
		console.log(help);
		const response = await API.graphql({
			query: mutations.updateHelpType,
			variables: {input: help},
			authMode: 'AMAZON_COGNITO_USER_POOLS',
		});
		console.log(response);
		return response;
	}

	const {control, handleSubmit} = helpsForm;

	const onSubmit = (data) => {
		// console.log(data);
		let helpValues = data;

		let parsed = Object.keys(helpValues)
			.filter((k) => helpValues[k] != null)
			.reduce((a, k) => ({...a, [k]: helpValues[k]}), {});

		delete parsed.createdAt;
		delete parsed.modified;
		delete parsed.updatedAt;

		if (!editMode) {
			createHelp(parsed);
			setRefreshHelps();
			setActiveView('helps');
			helpsForm.reset();
		} else {
			parsed.id = help.id;
			updateHelp(parsed);
			setRefreshHelps();
			setActiveView('helps');
			helpsForm.reset();
		}
	};

	return (
		<Form onSubmit={handleSubmit(onSubmit)}>
			<DetailItem>
				<FieldWrapper>
					<Controller
						name="name"
						control={control}
						defaultValue={(help && help.name) || ''}
						render={({field}) => (
							<TextField
								label="Name"
								variant="outlined"
								type="text"
								autoComplete="foo"
								{...field}
							/>
						)}
					/>
				</FieldWrapper>
			</DetailItem>
			<DetailItem>
				<FieldWrapper>
					<Controller
						name="description"
						control={control}
						render={({field}) => (
							<TextField
								multiline
								label="Description (optional)"
								rows={8}
								variant="outlined"
								defaultValue={(help && help.description) || ''}
								autoComplete="foo"
								{...field}
							/>
						)}
					/>
				</FieldWrapper>
			</DetailItem>
			<Button
				type="submit"
				variant="contained"
				color="primary"
				disableElevation>
				Save
			</Button>
		</Form>
	);
};

export default HelpsTypeForm;
